import { render, staticRenderFns } from "./Mesa.vue?vue&type=template&id=46f77832&scoped=true&"
import script from "./Mesa.vue?vue&type=script&lang=js&"
export * from "./Mesa.vue?vue&type=script&lang=js&"
import style0 from "./Mesa.vue?vue&type=style&index=0&id=46f77832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f77832",
  null
  
)

export default component.exports